import { ref } from 'vue'

const items = ref([])

const load = () => {
    items.value = Object.keys(localStorage)
        .filter(k => k.startsWith('request-'))
        .map(k => JSON.parse(localStorage.getItem(k)))
        .sort((a, b) => (a.traceId < b.traceId ? 1 : -1))
}

const add = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value))
    load() // обновляем реф
}

const remove = (key) => {
    localStorage.removeItem(key)
    load()
}

const clearAll = () => {
    Object.keys(localStorage)
        .filter(k => k.startsWith('request-'))
        .forEach(k => localStorage.removeItem(k))
    load()
}

// слушаем другие вкладки
window.addEventListener('storage', (e) => {
    if (e.key?.startsWith('request-')) {
        load()
    }
})

load() // начальная загрузка

export default {
    items,
    add,
    remove,
    clearAll,
    load
}
